const mobileToggleElement = document.querySelector("#hamburger");
const header = document.querySelector(".header");
const mainNav = document.querySelector(".header-bottom .main-nav");

function mobileToggle() {
    if (mobileToggleElement) {
        mobileToggleElement.addEventListener("click", () => {
            document.body.classList.toggle("mobile-nav-open");
        });
    }
}

function scrollHeader() {
    window.addEventListener("scroll", function() {
        if (header && mainNav) {
            const offsetY = window.scrollY || window.pageYOffset;
            const treshold = header.scrollHeight - mainNav.scrollHeight / 2;

            if (offsetY > treshold) {
                header.classList.add("header--scrolled");
            } else {
                header.classList.remove("header--scrolled");
            }
        }
    });
}

export default function() {
    mobileToggle();
    scrollHeader();
}
